import React from 'react'
import PropTypes from 'prop-types';

import Button from '../button/button'
import ButtonPush from '../button/button-push'
import Switch from '../form/form-switch'

import Scheduling from './components/scheduling'
import SchedulingTitle from './components/scheduling-title'
import * as modules from './components/_index';

import './module.styl'
import './components/components.styl'
class ModuleSchedule extends React.Component {

    constructor(props){
        super(props)
        this.state = {
            open: false,
            type: props.type,
            module: props.module,
            disabled: false
        }
    }

    open() {
        this.state.open = !this.state.open
        this.setState(this.state)
    }

    default(newValue) {
        this.state.module.options.isCustom = !this.state.module.options.isCustom
        this.setState(this.state)
    }

    visible() {
        this.state.module.visibility = !this.state.module.visibility
        this.setState(this.state)
    }

    disabled(newValue){
        this.state.disabled = !this.state.disabled
        this.setState(this.state)
    }

    UNSAFE_componentWillReceiveProps(nextProps, nextState) {
        this.setState({disabled: nextProps.disabled})
    }

    render() {
        let { type, module, disabled, open } = this.state
        let moduleType = modules[type.replace(/-/g, '_')]

        return <div className={"module-schedule" + (module.visibility ? '' : ' disabled')}>
            <ButtonPush onClick={this.open.bind(this)} value={open} iconOn='minus' iconOff='plus' />
            <ButtonPush onClick={this.visible.bind(this)} value={module.visibility} iconOn='eye' iconOff='eyeBlocked' />

            {!open && <SchedulingTitle onChange={console.log} data={module}/>}

            { open && <div className="module-schedule-content">
                <Scheduling disabled={disabled} onChange={console.log} data={module} />

                <Switch onChange={this.default.bind(this)}
                        disabled={disabled}
                        checked={module.options.isCustom}
                        label={'app.modules.customOrDefault'}
                        labelLeft={'app.modules.default'}
                        labelRight={'app.modules.custom'} />

                {module.options.isCustom && React.createElement(moduleType, { onChange: console.log, ...module.options, disabled })}

                <Button label="app.edit" onClick={ this.disabled.bind(this) } />
            </div>}
        </div>
    }
}

ModuleSchedule.propTypes = {
    type: PropTypes.string.isRequired,
    module: PropTypes.object.isRequired
}

export default ModuleSchedule;
